import { useEffect, useState } from 'react';
import axios from 'axios';
import { History } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fmt = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' }) : '—');
const state = (v) => (v === null || v === undefined ? '?' : v ? 'ON' : 'OFF');

// Permanent feature-flag change log (latest first).
export function FlagHistoryPanel() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open || items) return;
    axios.get(`${API_URL}/api/feature-flags/history`, { withCredentials: true, params: { limit: 100 } })
      .then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  }, [open, items]);
  return (
    <details className="mb-6 bg-[#0C0612] border border-[#2A0F3D]" onToggle={(e) => setOpen(e.currentTarget.open)} data-testid="flag-history-panel">
      <summary className="cursor-pointer px-5 py-3 font-mono text-sm font-bold text-[#00F0FF] flex items-center gap-2">
        <History className="w-4 h-4" /> FLAG_CHANGE_HISTORY
      </summary>
      <div className="px-5 pb-4">
        {!items ? <p className="font-mono text-xs text-[#4B6B52]">Loading…</p> : items.length === 0 ? (
          <p className="font-mono text-xs text-[#4B6B52]" data-testid="flag-history-empty">// No changes recorded yet.</p>
        ) : (
          <ul className="divide-y divide-[#2A0F3D] max-h-80 overflow-y-auto">
            {items.map((h, i) => (
              <li key={`${h.key}-${h.at}-${i}`} className="py-2 font-mono text-[11px] text-[#A3C7A8]" data-testid={`flag-history-row-${i}`}>
                <span className="text-white">{h.key}</span> · {state(h.from)} → <b className={h.to ? 'text-[#39FF14]' : 'text-[#FF3B30]'}>{state(h.to)}</b>
                <span className="text-[#6B8E73]"> · {h.by || 'unknown'} · {fmt(h.at)}</span>
                {h.note && <span className="text-[#FF9F0A]"> · {h.note}</span>}
              </li>
            ))}
          </ul>
        )}
      </div>
    </details>
  );
}
